module.exports = "/_next/static/images/55652290137b62ef1f6a033acaf041c9-rewards-app-md@1x.png";